import { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Collapsible } from '@openedx/paragon';

import courseOutlineMessages from '@src/course-home/outline-tab/messages';
import { useCourseOutlineSidebar } from '@src/courseware/course/sidebar/sidebars/course-outline/hooks';
import CompletionIcon from './generic/CompletionIcon';
import SidebarUnit from './SidebarUnit';
import { UNIT_ICON_TYPES } from './UnitIcon';
import OutlineItemTitle from './generic/OutlineItemTitle';

const SidebarSequence = ({
  courseId,
  defaultOpen,
  sequence,
  activeUnitId,
}) => {
  const intl = useIntl();

  const {
    id,
    complete,
    title,
    specialExamInfo,
    unitIds,
    type,
    completionStat,
  } = sequence;
  const [open, setOpen] = useState(defaultOpen);
  const { units } = useCourseOutlineSidebar();

  const sectionTitle = (
    <OutlineItemTitle
      icon={<CompletionIcon completionStat={completionStat} />}
      title={title}
      subtitle={specialExamInfo}
      screenreaderMessage={
        intl.formatMessage(complete ? courseOutlineMessages.completedAssignment
          : courseOutlineMessages.incompleteAssignment)
      }
      fontWeight="medium"
    />
  );

  return (
    <Collapsible.Advanced
      open={open}
      onToggle={() => setOpen(!open)}
    >
      <Collapsible.Trigger className="outline-item-hover">
        {sectionTitle}
      </Collapsible.Trigger>
      <Collapsible.Body>
        <ol className="list-unstyled unit-list">
          {unitIds.map((unitId) => (
            <SidebarUnit
              key={unitId}
              id={unitId}
              courseId={courseId}
              sequenceId={id}
              unit={units[unitId]}
              isActive={activeUnitId === unitId}
              activeUnitId={activeUnitId}
              isLocked={type === UNIT_ICON_TYPES.lock}
            />
          ))}
        </ol>
      </Collapsible.Body>
    </Collapsible.Advanced>
  );
};

SidebarSequence.propTypes = {
  courseId: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool.isRequired,
  sequence: PropTypes.shape({
    complete: PropTypes.bool,
    id: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    specialExamInfo: PropTypes.string,
    unitIds: PropTypes.arrayOf(PropTypes.string),
    completionStat: PropTypes.shape({
      completed: PropTypes.number,
      total: PropTypes.number,
    }),
  }).isRequired,
  activeUnitId: PropTypes.string.isRequired,
};

export default SidebarSequence;
